<template>
  <div>
    <Meal
    v-for="meal in meals"
    v-bind:key="meal.code"
    v-bind:code="meal.code"
    v-bind:name="meal.name"
    v-on:dishes:choose="onChooseDishes"
    ></Meal>
    <div class="row">
      <center class="w-100">
        <button type="button" class="btn btn-primary m-2" v-on:click="calculate">
          {{mealListUI.buttons.Calculate}}
        </button>
      </center>
    </div>
    <div class="row">
      <h5 class="font-weight-bold">{{mealListUI.labels.Result}}</h5>
      <table class="table table-striped">
        <thead class="table-primary">
          <tr>
            <th scope="col">{{mealListUI.labels.Nutritions}}</th>
            <th scope="col">{{mealListUI.labels.NutritionsInMeal}}</th>
            <th scope="col">{{mealListUI.labels.RecommendedNutritionsInMeal}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-light">
            <th scope="row">{{mealListUI.labels.Energy}}</th>
            <td>{{this.nutrition.energy}}</td>
            <td><b>{{this.recommendedNutrition.energy}}</b> kcalo</td>
          </tr>
          <tr class="table-secondary">
            <th scope="row">{{mealListUI.labels.Protid}}</th>
            <td>{{this.nutrition.protid}}</td>
            <td><b>{{this.recommendedNutrition.protid}}</b> gam</td>
          </tr>
          <tr class="table-light">
            <th scope="row">{{mealListUI.labels.Lipid}}</th>
            <td>{{this.nutrition.lipid}}</td>
            <td><b>{{this.recommendedNutrition.lipid}}</b> gam</td>
          </tr>
          <tr class="table-secondary">
            <th scope="row">{{mealListUI.labels.Glucid}}</th>
            <td>{{this.nutrition.glucid}}</td>
            <td><b>{{this.recommendedNutrition.glucid}}</b> gam</td>
          </tr>
          <tr class="table-light">
            <th scope="row">{{mealListUI.labels.Canxi}}</th>
            <td>{{this.nutrition.canxi}}</td>
            <td><b>{{this.recommendedNutrition.canxi}}</b> mg</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Meal from './Meal'
import { MealListUI } from '../lang/vn.js'

export default {
  name: 'MealList',
  components: {
    Meal
  },
  data () {
    return {
      meals: [
        {
          code: 'breakfast',
          name: 'Bữa ăn sáng'
        },
        {
          code: 'lunch',
          name: 'Bữa ăn trưa'
        },
        {
          code: 'dinner',
          name: 'Bữa ăn chiều'
        }
      ],
      chosenDishes: {},
      nutrition: {
        energy: 0,
        protid: 0,
        lipid: 0,
        glucid: 0,
        canxi: 0
      },
      recommendedNutrition: {
        energy: '2572',
        protid: '76-96',
        lipid: '63-71',
        glucid: '386-450',
        canxi: '1000'
      },
      showNutrition: false,
      mealListUI: MealListUI
    }
  },
  methods: {
    calculate: function () {
      this.reset()

      for (let meal in this.chosenDishes) {
        for (let dish in this.chosenDishes[meal]) {
          let dishInfo = this.chosenDishes[meal][dish]
          for (let el in this.nutrition) {
            this.nutrition[el] += dishInfo[el] * dishInfo.count
          }
        }
      }
      for (let key in this.nutrition) {
        this.nutrition[key] = Math.round(this.nutrition[key] * 100) / 100
      }
    },
    reset: function () {
      this.nutrition = {
        energy: 0,
        protid: 0,
        lipid: 0,
        glucid: 0,
        fiber: 0,
        canxi: 0
      }
    },
    onChooseDishes: function (chosenDisheInfo) {
      let { meal, chosenDishes } = chosenDisheInfo

      for (let code in chosenDishes) {
        if (!this.chosenDishes.hasOwnProperty(meal)) {
          this.chosenDishes[meal] = {}
        }
        if (chosenDishes[code].count === 0) {
          delete this.chosenDishes[meal][code]
          continue
        }
        this.chosenDishes[meal][code] = chosenDishes[code]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MealList.vue